export const propertyNavbar = ['$scope', '$window', '$timeout', function($scope, $window, $timeout) {
  $scope.scrollDir = 0
  $scope.scrollPos = 0
  $scope.isScrolling = false
  $scope.throttled = false
  // var isScrolling
  var mobileNavbar = document.querySelector('#property-navbar-mobile.overview')
  var minimalNavThreshold = 250

  angular.element($window).on('scroll', function(e) {
    if (!$scope.throttled) {
      $scope.throttled = true
      // $scope.scrollDir = $window.scrollY > $scope.scrollPos ? 'down' : 'up'
      // $scope.scrollPos = $window.scrollY

      if (mobileNavbar && $window.scrollY > minimalNavThreshold) {
        mobileNavbar.classList.remove('minimal')
      } else if (mobileNavbar && $window.scrollY <= minimalNavThreshold) {
        mobileNavbar.classList.add('minimal')
      }

      $timeout(function() {
        $scope.throttled = false
      }, 100)
    }
  })

  // angular.element($window).on('scroll', function(e) {
  //   $scope.isScrolling = true
  //   // $scope.$apply()
  //   $timeout.cancel(isScrolling);
  //   isScrolling = $timeout(function () {
  //     $scope.isScrolling = false
  //   }, 500);
  // })
}]